import { useEffect, useRef ,useState } from "react";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import Nebula, { SpriteRenderer } from "three-nebula";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { Vector3D } from "three-nebula/build/cjs/math";
import { Color } from "three-nebula/build/cjs/behaviour";
import  Util  from "./utils";
//import * as Tetavi from '../TetaviBundle'
// import * as THREE from "three";

const THREE = window.Tetavi.THREE;


const GlbObj = (props) => {
  
  const [init, setInit] = useState(false);
  const [mixer, setMixer] = useState(null);
  const [gltf, setGltf] = useState(null);
  const [pivot, setPivot] = useState(null);
  const [particlePivot, setParticlePivot] = useState(null);
  const [nebula, setNebula] = useState(null);
  const [video, setVideo] = useState(null);
  const [particleBone, setParticleBone] = useState("");
  const [numClicks, setNumClicks] = useState(0);
  const [glbsObjects, setGlbsObjects] = useState([]);
  const loader = new GLTFLoader(props.loadingManager);
  let saved_frame = -1;
  let saved_to = -1;
  let saved_from = -1;
  let saved_alpha = -1;
  let nebulaFrame = 0;
  let nebulaRootPositionSearched = false;
  let colorBlack = new THREE.Color( 0  , 0, 0 );;
  let obj
  
  let nebulaPositions = [];
function remove(){
  let pivotTemp = props.pivot;
  pivotTemp.scale.set(0,0,0)
  setPivot(pivotTemp)
  let pivotParticleTemp = particlePivot;
  if(pivotParticleTemp){
    pivotParticleTemp.scale.set(0,0,0)
    setParticlePivot(pivotParticleTemp)
  }
}
function appear(){
  let pivotTemp = props.pivot;
  pivotTemp.scale.set(10,10,10)
  setPivot(props.pivot)
  let pivotParticleTemp = particlePivot;
  if(pivotParticleTemp){
    pivotParticleTemp.scale.set(1,1,1)
    setParticlePivot(pivotParticleTemp)
  }
  
}

function hide(bool){
  gltf.scene.visible = !bool;
}

useEffect(() => {
  if(!props.glb) return
    const draco = new DRACOLoader();
    draco.setDecoderConfig({ type: 'js' });
    draco.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
    loader.setDRACOLoader(draco);
    loader.loadAsync( props.glb.path, ()=>{} ).then(gltf => {
      if(!gltf.scene){
        console.log('\x1b[36m%s\x1b[0m',props.glb.path + " failed to load")
        
        return
      } 
      setGltf(gltf);
    });
    
  
}, [props.glb]);


useEffect(() => {
    if(gltf)
      gltf.scene.clicableBoundingBox.numClicks = numClicks
  
}, [numClicks]);



function creatBoundingBox(){
  
  if(!props.glb.clickable || !props.config.functions || !props.config.functions[props.glb.clickable.onClick] ) return null
  if(gltf.animations.length == 0) return null

  if(!gltf.scene.clicableBoundingBox){
    var geometry = new THREE.SphereGeometry( 5, 3, 2 );
    var material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
    material.wireframe = true;
    
    var sphere = new THREE.Mesh( geometry, material );
    sphere.visible = props.debug
    if(props.glb.clickable.boundingboxScale){
      sphere.scale.set(props.glb.clickable.boundingboxScale[0],props.glb.clickable.boundingboxScale[1],props.glb.clickable.boundingboxScale[2])
    }
      
    sphere.position.set(-1000,0,0)
    sphere.name= "clickable"
    sphere.numClicks = numClicks
    sphere.setNumClicks = setNumClicks
    sphere.changeVertShader = changeVertShader
    sphere.onClick = new Function(props.config.functions[props.glb.clickable.onClick].arguments, props.config.functions[props.glb.clickable.onClick].body);
    gltf.scene.clicableBoundingBox = sphere
    props.scene.add(gltf.scene.clicableBoundingBox)

  }
    const bframe = (saved_frame*3) % gltf.animations[0].tracks[0].values.length
    let offset = [0,0,0]
    if(props.glb.clickable.position){
      offset = props.glb.clickable.position
    }
    gltf.scene.clicableBoundingBox.position.set(getAnimationValue(bframe) + offset[0],getAnimationValue(bframe+1)+ offset[1],getAnimationValue(bframe+2)+ offset[2])
    
  
  gltf.scene.clicableBoundingBox.updateMatrixWorld();
  return gltf.scene.clicableBoundingBox
  
}

function getAnimationValue(bframe){
  
  return gltf.animations[0].tracks[0].values[bframe]*10
}


useEffect(() => {
  
      if(!gltf) return
      if(!init ){
        setInit(true)
      
				
      let mixertmp = new THREE.AnimationMixer( gltf.scene );
      
      let clips = gltf.animations;
      if (clips) {
        clips.forEach( function ( clip ) {
          mixertmp.clipAction( clip ).play();
        } );
      } 
      mixertmp.setTime(0);
      setMixer(mixertmp);
      gltf.scene.hide = hide;
      
    }
}, [gltf]);
useEffect(() => {
  if(!video && props.glb.videoId && gltf){
    let videoTmp = document.getElementById( props.glb.videoId)
    let texture = new THREE.VideoTexture( videoTmp );
    
    texture.generateMipmaps = false;
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.anisotropy = 16
    texture.format = THREE.RGBAFormat;
    texture.needsUpdate = true;
    

    if(gltf && texture){
      
      texture.flipY = false;
      gltf.scene.traverse( function( object ) {
        
        if ( object.isMesh ){
          object.material = new THREE.MeshBasicMaterial({map: texture});
          object.material.toneMapped =false
          object.material.needsUpdate = true;
        } 
  
      } );
    }
    
    setVideo(videoTmp)
  }
  if(mixer && gltf && props.glb.shaders && props.config )
  {
    gltf.scene.tick = (delta,frame) => Tick(delta,frame);
    gltf.scene.glbIndex = props.index;
    props.updateables.push(gltf.scene)
    props.setUpdateables(props.updateables);
    let pivotTemp = props.pivot;
    
    
    if(props.glb.frameIn > 0 ){
      pivotTemp.scale.set(0,0,0)
    }
    else{
      pivotTemp.scale.set(10,10,10)
    }
  
  
  gltf.scene.traverse( function( object ) {
    
    if ( object.isMesh ){
      glbsObjects.push(object)
      setGlbsObjects(glbsObjects)
      if(props.glb.object){
        for (const property in props.glb.object) {
          object[property] = props.glb.object[property]
        }
      }
      object.material = Util.setFromConfig(object.material,props.glb.material)
      
      object.material.uniformsNeedUpdate = true
      object.material.needsUpdate = true
      

    } 
  });
  if(props.glb.shaders.length > 0){
    let replace_array = []
    for(const replaceShader of props.glb.shaders ){
      replace_array.push({to_replace:props.config.shaders[replaceShader].to_replace,replace_with:props.config.shaders[replaceShader].replace_with})
      
    }
    changeVertShader(replace_array)
  }
  gltf.scene.creatBoundingBox = creatBoundingBox;
  gltf.scene.getBoneAnimation = getBoneAnimation;
  pivotTemp.add(gltf.scene)
  props.scene.add( pivotTemp );
  setPivot(pivotTemp)
  if(props.glb.particle && props.glb.particle.particle)
  {
    if(props.particle.particle.length >=0)
      fetchParticle(props.glb.particle.particle);
    
  }
}

}, [mixer,props.glb,props.config]);

function getBoneAnimation(){
  return gltf.animations

}
// replace array 
//  [
//    {"to_replace":"#include <begin_vertex>", "replace_with":"vec3 transformed = vec3(position);float dx = position.x;float dz = position.z;float freqC = sqrt(dx*dx + dz*dz);float amp = 0.1;float angle = -time*10.0 + freqC*18.0 + freq*2.0;transformed.y += sin(angle)*amp ;"},
//    {"to_replace":"#include <common>", "replace_with":"#include <common>uniform float time;uniform float freq;"}
//  ]
function changeVertShader(replaceArray){
  gltf.scene.traverse( function( object ) {

    if ( object.isMesh ){
      
      object.material.onBeforeCompile = (info) => {
        for(const shader_replace of replaceArray){
          info.vertexShader = info.vertexShader
        .replace(shader_replace.to_replace,
          shader_replace.replace_with)
        
          info.uniforms.freq = { value: 0 };
          info.uniforms.time = { value: 0}
          object.material.userData.shader = info;
          
        }
      }
      object.material.needsUpdate = true
        
    } 
  });
}



const fetchParticle=(particleName)=>{
  
  fetch(particleName + '.json'
  ,{
    headers : { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
     }
  }
  )
    .then(function(response){
      return response.json();
    })
    .then(function(particle) {
      
      Nebula.fromJSONAsync(particle, THREE).then(loaded => {
        const piv = new THREE.Object3D()
        piv.scale.set(1,1,1);
        const nebulaRenderer = new SpriteRenderer(piv, THREE);
        props.scene.add(piv);
        setParticlePivot(piv)
        const nebulat = loaded.addRenderer(nebulaRenderer);
        setParticleBone(props.particle.bone)
        setNebula(nebulat);
      });
        
    });
}


useEffect(() => {
  if(nebula && pivot && gltf)
  {
  
    gltf.scene.tick = (delta,frame) => Tick(delta,frame);
  }
}, [nebula,particlePivot]);

function lerp(a, b, t) {
  return (1 - t) * a + t * b;
}

async function changeMaterial(frame){
  
  for(const obj of glbsObjects){
    
    if(obj.material.PerFrameFunctions){
      for(const objFunc of obj.material.PerFrameFunctions){
        objFunc(obj.material,frame)
      }
    }
  }
}

async function Tick(delta,frame){
  changeMaterial(frame)
    
  

  if(frame > props.glb.frameIn && (!props.glb.frameOut || frame < props.glb.frameOut)){
    if(!pivot || pivot.scale.x == 0)
      appear();
    if(mixer && saved_frame != frame){
      if(!nebulaRootPositionSearched && (gltf.animations.length >= 1 && gltf.animations[0].tracks.length >= 1)){
        
          for(const track of gltf.animations[0].tracks){
            if(track.name == particleBone){
              nebulaPositions = track.values;
              break;
            }
          }
        }
        nebulaRootPositionSearched = true;
      if(nebulaPositions.length > 0){
        if(nebula){
          nebulaFrame += 3;
          if(nebulaFrame+2 > nebulaPositions.length){
            nebulaFrame = 0;
          } 
          nebula.renderers[0].container.position.set(nebulaPositions[nebulaFrame],nebulaPositions[nebulaFrame+1],nebulaPositions[nebulaFrame+2])
          nebula.update();
        }
          
      }
      mixer.setTime(frame/30)
      // mixer.update(1/30);
    }
      
  }else{
    if(pivot && pivot.scale.x != 0){
      if(props.glb.frameIn > 0 && props.glb.frameOut > 0){
        remove();
        mixer.setTime(0)
        nebulaFrame=0;
      }
        

    }
      
  }
  saved_frame = frame;
  

}

useEffect(() => {
  if(props.playState == 'first_play' && video){
    
    video.play()
  }
  if((props.playState == 'pause' || props.playState == 'buffering')&& video){
    video.pause()
      
  }
  if(props.playState == 'play' && video){
      video.play()
  }
    
}, [props.playState,video]);


  
  return (
    <div >
    </div>
    
  );
}

export default GlbObj;
